<template>
  <v-dialog name="asd" v-model="modalComputed" persistent scrollable max-width="780" v-if="filialComputed !== undefined">

    <v-card flat>

      <v-toolbar flat color="accent">
        <v-btn icon @click="modalComputed = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>M&aacute;quina POS - Filial {{filialComputed.cc_fil}}</v-toolbar-title>
      </v-toolbar>

      <v-card-text class="ma-0 pa-0">
        <v-container>
          <v-row>
            <v-col>
              <div v-if="itens.length === 0">
                <v-alert text type="info" color="primary">N&atilde;o h&aacute; m&aacute;quina POS cadastrada para esta empresa</v-alert>
              </div>

              <v-simple-table v-else>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>Ident</th>
                      <th>Num. Série</th>
                      <th>Credenciadora</th>
                      <th>Merchant ID</th>
                      <th width="30"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in itens" :key="item.id_reg">
                      <td>{{ item.ds_pos }}</td>
                      <td>{{ item.cc_num_ser }}</td>
                      <td>{{ formataCNPJ(item.cc_ins_fed_cre) }}</td>
                      <td>{{ item.tx_merc_id }}</td>
                      <td>
                        <v-tooltip left>
                          <template v-slot:activator="{ on }">
                              <v-btn depressed small fab color="primary" v-on="on" @click="deletar(item)">
                                <v-icon>mdi-delete</v-icon>
                              </v-btn>
                          </template>
                          <span>Deletar</span>
                        </v-tooltip>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>

              <v-card outlined>
                <v-card-text>
                  <v-form  ref="form" v-model="valid" :lazy-validation="lazy" class="mt-2" v-on:submit.prevent>
                    <div class="d-flex flex-column">
                        <div class="d-flex flex-row">
                          <v-text-field v-model="pos.ds_pos" label="Identificador" :rules="validacao.ds_pos" class="mr-2"></v-text-field>
                          <v-text-field v-model="pos.cc_num_ser" label="Num. Série" :rules="validacao.cc_num_ser" class="mr-2"></v-text-field>
                          <v-text-field v-model="pos.cc_ins_fed_cre" label="CNPJ Credenciadora" :rules="validacao.cc_ins_fed_cre" class="mr-2"></v-text-field>
                          <v-text-field v-model="pos.tx_merc_id" label="Merchant ID" :rules="validacao.tx_merc_id" class="mr-2"></v-text-field>
                        </div>
                    </div>
                    <v-btn depressed outlined @click="inserir()" color="primary">SALVAR</v-btn>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

    </v-card>
  </v-dialog>
</template>
<script>
export default {

  name: 'PontoDeVenda',

  data() {
    return {

      valid: true,
      lazy:true,
      itens:[],

      pos: {
        cc_fil: undefined,
        ds_pos: undefined,
        cc_num_ser: undefined,
        tx_cha_adq: '26359854-5698-1365-9856-965478231456',
        cc_ins_fed_cre: undefined,
        tx_merc_id: undefined,
      },

      validacao: {
        ds_pos: [
          (v) => !!v || 'Requerido',
        ],
        cc_num_ser: [
          (v) => !!v || 'Requerido',
        ],
        tx_cha_adq: [
          (v) => !!v || 'Requerido',
        ],
        cc_ins_fed_cre: [
          (v) => !!v || 'Requerido',
          (v) => /^[0-9]{14}$/.test(v) || 'Formato inválido'
        ],
        tx_merc_id: [
          (v) => !!v || 'Requerido'
        ]
      },

      filialTemp: undefined,
      modalTemp: undefined
    }
  },

  props: {

    filial: {
      required: true
    },

    modal: {
      required: true,
      type: Boolean
    },

  },

  methods: {

    formataCNPJ(cnpj){
      if (cnpj.match(/\d{14}/)) {
        return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
      }
      return cnpj
    },

    listar() {
      this.itens = []
      if(this.filialComputed !== undefined) {
        this.$store.dispatch('pesquisaPOS', {size:9999, cc_fil: this.filialComputed.cc_fil}).then(resp => {
           resp.data.content.forEach(el => {
             this.itens.push(el)
           });
         }).catch()
      }
    },

    inserir() {
      if (this.$refs.form.validate()) {
          this.pos.cc_fil = this.filialComputed.cc_fil
        this.$store.dispatch('salvarPOS', this.pos).then(() => {
          this.listar()
          this.resetarFormulario()
        }).catch()
      }
    },

    deletar(item) {
      this.$store.dispatch('deletarPOS', item.id_reg).then(() => {
        this.listar()
      }).catch()
    },

    resetarFormulario(){
      this.$refs.form.reset()
    },

  },

  computed: {
    modalComputed :  {
      get: function() { 
        return this.modalTemp
      },
      set: function(value) {
        this.modalTemp = value
      }
    },
    filialComputed: {
      get: function() { 
        return this.filialTemp
      },
      set: function(value) {
        this.filialTemp = value
      }
    }
  },

  mounted: function() {
    this.listar()
  },

  created: function() {

    this.modalComputed = this.modal
    this.filialComputed = this.filial
    this.$emit('a')
  }

}
</script>